export const generateBGColorClassName = (n) => {
  const colors = [
    "bg-orange-400",
    "bg-cyan-400",
    "bg-pink-400",
    "bg-teal-400",
    "bg-salmon-400",
    "bg-deep-purple-400",
    "bg-primary-400",
  ];

  return colors?.length > n ? colors[n] : colors[n % colors.length];
};

export const randomChartColors = (n) => {
  const colors = [
    "#80CBC4",
    "#A5D6A7",
    "#90CAF9",
    "#F48FB1",
    "#CE93D8",
    "#F48FB1",
    "#A5D6A7",
    "#90CAF9",
  ];
  return colors?.length > n ? colors[n] : colors[n % colors.length];
};
